import Swiper from "swiper";

document.addEventListener('DOMContentLoaded', () => {
    addRecentObjectsSwiper();
    disableGravityFormFields();
})

const disableGravityFormFields = () => {
    const fields = document.querySelectorAll('li.gf_readonly input');
    if (fields.length === 0) {
        return;

    }

    fields.forEach(field => {
        console.log('test');
        field.readOnly = true;
    })
}

const addRecentObjectsSwiper = () => {
    const swipers = document.querySelectorAll('.recent-objects .swiper-container');
    if (swipers.length === 0) {
        return;
    }

    swipers.forEach(swiper => {
        new Swiper(swiper, {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            loop: false,
            slidesPerView: 3,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                690: {
                    slidesPerView: 2,
                },
                1000: {
                    slidesPerView: 3,
                }
            },
            autoHeight: false,
            spaceBetween: 24,
        });
    })
}